import request from "@/util/axios";

// 共享变量
var _YHCS_order_tmp_ = {};

const YHCS_get_order = function (YHCS_tradeNo) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("YHCS_tradeNo", YHCS_tradeNo);

    // 查询待支付订单信息 主要是金额
    request.post("/mall/rc-yhcs-order-fee", formData).then((res) => {
      budo_log.info("#14 rc-yhcs-order-fee, res=", res);

      if (res && res.data) {
        res.data.orderFee = Number(res.data.totalAmount) * 100;

        _YHCS_order_tmp_ = res.data;
        resolve(res.data);
        return;
      }

      reject("rc-yhcs-order-fee err");
    });
  });
};

const YHCS_order_info_for_pay = function (cards) {
  budo_log.info("#30 _YHCS_order_tmp_=", _YHCS_order_tmp_, "cards=", cards);

  _YHCS_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _YHCS_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _YHCS_order_tmp_.goodsList = [];

  _YHCS_order_tmp_.orderType = "YHCS";
  _YHCS_order_tmp_.goodsType = "YHCS";
  _YHCS_order_tmp_.tradeno = _YHCS_order_tmp_.tradeNo;
  _YHCS_order_tmp_.expressFee = 0;

  _YHCS_order_tmp_.cardMoney = _YHCS_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);
  _YHCS_order_tmp_.wxPayFee =
    _YHCS_order_tmp_.orderFee - _YHCS_order_tmp_.cardMoney;

  return _YHCS_order_tmp_;
};

export { YHCS_get_order, YHCS_order_info_for_pay };
